import { Button, TextArea } from '@hevoio/hevo-ui-toolkit';
import React, { useState } from 'react';
import styles from './QuestionTypeContent.module.scss';
import clsx from 'clsx';
import { SolutionRequest } from '../../interfaces/query';
export default function QuestionTypeContent({
  onGetSolution
}: {
  onGetSolution: (question: SolutionRequest) => void;
}) {
  const [question, setQuestion] = useState('');
  const [questionError, setQuestionError] = useState('');

  const handleFindSolution = () => {
    if (!question.trim()) {
      setQuestionError('Question is required');
      return;
    }
    onGetSolution({ issueDescription: question });
  };

  const onChangeHandler = (value: string) => {
    setQuestion(value);
    setQuestionError('');
  };

  return (
    <div className={styles.questionTypeContent}>
      <div className={'text-label-small mt-2 mb-2'}>Ask your question*</div>
      <TextArea
        onChangeHandler={onChangeHandler}
        onEnter={handleFindSolution}
        style={{ height: 100 }}
        className={clsx(styles.questionTypeContentTextArea, questionError && 'error-border')}
        placeholder='Can I schedule my Pipeline to run at specific times? '
      />
      
      {questionError && <div className={'text-caption-1 text-error mt-1'}>{questionError}*</div>}
      
      <div className='d-flex justify-content-center justify-end mt-4'>
        <Button className='text-transform-none' onClick={handleFindSolution}>Find an answer</Button>
      </div>
    </div>
  );
}
